const CAPTURE_SCORE_THRESHOLD = process.env.CAPTURE_SCORE_THRESHOLD || 80
import { FC, memo, useMemo } from "react"
import classNames from "classnames"
import VitalItem from "./VitalItem"
import GradientIndicator from "@/components/GradientIndicator"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import "./index.scss"

interface VitalSummaryCardProps {
   iconName: IconProps["name"]
   title: string
   rateTitle: string
   inmateMoving: boolean
   vital: number
   vitalRate: number | null
   captureQuality: number
   totalCount: number | null
}

const VitalSummaryCard: FC<VitalSummaryCardProps> = ({
   iconName,
   title,
   rateTitle,
   inmateMoving,
   vital,
   vitalRate,
   captureQuality,
   totalCount,
}) => {
   const vitalStable = useMemo(() => {
      return captureQuality > Number(CAPTURE_SCORE_THRESHOLD)
   }, [captureQuality])

   return (
      <div className="vital-summary-card">
         <span className="vital-summary-card__header">
            <span className="vital-summary-card__title">
               <Icon
                  name={iconName}
                  size="28"
                  color={IconColor.HONOLULU_BLUE}
               />
               <span>{title}</span>
            </span>
         </span>
         <span className="vital-summary-card__vitals">
            <VitalItem
               inmateMoving={inmateMoving}
               title={rateTitle}
               value={vital}
               vitalStable={vitalStable}
            />
            <VitalItem
               title="avg rate"
               value={vitalRate}
               subTitle="last 24 hr"
               totalCount={totalCount}
            />
            <span
               className={classNames(
                  "vital-summary-card__vital-info",
                  "vital-summary-card__vital-info--centered"
               )}
            >
               <span className="vital-summary-card__vital-info-title">
                  Capture quality
               </span>
               <GradientIndicator
                  className="vital-summary-card__gradient-indicator"
                  value={captureQuality}
               />
            </span>
         </span>
      </div>
   )
}

export default memo(VitalSummaryCard, (prevProps, nextProps) => {
   return (
      prevProps.inmateMoving === nextProps.inmateMoving &&
      prevProps.vital === nextProps.vital &&
      prevProps.vitalRate === nextProps.vitalRate &&
      prevProps.captureQuality === nextProps.captureQuality &&
      prevProps.totalCount === nextProps.totalCount
   )
})
